import { ComponentClassNames } from '../../../../util/classNames';
import { Depth, getDepthBoxShadow } from '../../../../util/styles/depth';
import { ZIndex } from '../../../../util/styles/zIndex';
import { memoizeFunction, mergeStyleSets } from '../../../../util/styling';

type HeaderClassNames = ComponentClassNames<'header'>;

export const getClassNames = memoizeFunction((): HeaderClassNames => {
  const boxShadow = getDepthBoxShadow(Depth.depth4);

  return mergeStyleSets({
    header: {
      boxShadow,
      zIndex: ZIndex.PageLayoutHeader,
    },
  });
});
